import { AlertClassColour, ConfigSystemParams, msSize } from 'src/app/core/consts';
import { AfterViewInit, Component, EventEmitter, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { catchError, Observable, throwError } from 'rxjs';
import { CompletedModalFormComponent } from '../../_pop-ups/completed-modal-form/completed-modal-form.component';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { FormControl, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { IdAndDescriptionDTO } from 'src/app/core/interfaces/general/id-description';
import { LastPassKillerService } from 'src/app/core/services/utelize/general/last-pass-killer-service';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TariffsUsageService } from 'src/app/core/services/utelize/system/tariff/tariffs-usage-service';
import { TariffUsageDTO } from 'src/app/core/models/system/tariff/tariff-usage.dto';
import { TypesBillingServiceService } from 'src/app/core/services/utelize/system/type/types-billing-service-service';
import { TypesCurrencyService } from 'src/app/core/services/utelize/system/type/types-currency-service';
import { TypesTariffService } from 'src/app/core/services/utelize/system/type/types-tariff-service';
import { WarningModalFormComponent } from '../../_pop-ups/warning-modal-form/warning-modal-form.component';

@Component({
  selector: 'app-tariffs-usage-modal-form',
  templateUrl: './tariffs-usage-modal-form.component.html',
  styleUrls: ['./tariffs-usage-modal-form.component.scss']
})

export class TariffsUsageModalFormComponent implements AfterViewInit, OnDestroy, OnInit {

  @Output() thisFormCancelled: EventEmitter<void>  =new EventEmitter<void>();
  @Output() thisFormSaved    : EventEmitter<number>=new EventEmitter<number>();
  
  @ViewChild('completedModalForm', { static: false }) completedModalForm!: CompletedModalFormComponent;
  @ViewChild('thisModalForm',      { static: false }) thisModalForm!     : TemplateRef<void>;
  @ViewChild('warningModalForm',   { static: false }) warningModalForm!  : WarningModalFormComponent;
  
  get modalBackGround() { let value: string | boolean=this.configSystemService.getValue(ConfigSystemParams.ModalBackGround, "TRUE");
                          return value=value.toUpperCase()=="STATIC" ? "static" : (value.toUpperCase()=="TRUE" ? true : false) }
                       
  private billingServiceTypeIdData!: IdAndDescriptionDTO[];
  private currencyTypeIdData!      : IdAndDescriptionDTO[];
  private initialStatus            : string="Please complete the following details";
  private newUsageTariff           : boolean=false;
  private tariffTypeIdData!        : IdAndDescriptionDTO[];
  private thisModalFormRef!        : NgbModalRef;
  private usageTariff              : TariffUsageDTO | undefined;
  private usageTariffId            : number | undefined;
  
  public alertColourOrderStatus : string=AlertClassColour.Grey;
  public alertColourProgress    : string=AlertClassColour.Grey;
  public curUser                : SystemUserDTO;
  public formTitle              : string="Usage Tariff";
  public progressInformation    : string=this.initialStatus;
  public progressInformationShow: boolean=false;
  public thisForm!              : UntypedFormGroup;
  public thisFormSubmitted      : boolean=false;

  //#region for Validators
  
  public tariffNameMaxLength: number=50;
  
  //#endregion  

  constructor(
    private authenticationService     : AuthenticationService,
    private configSystemService       : ConfigSystemService,
    private exceptionsService         : ExceptionsService,
    private formBuilder               : UntypedFormBuilder,
    private lastPassKillerService     : LastPassKillerService,
    private modalService              : NgbModal,
    private tariffsUsageService       : TariffsUsageService,
    private typesBillingServiceService: TypesBillingServiceService,
    private typesCurrencyService      : TypesCurrencyService,
    private typesTariffService        : TypesTariffService
  ) {
    this.curUser=this.authenticationService.currentUserObject();
  }

  public ngOnInit(): void {
    try {

    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngAfterViewInit(): void {
    try {
      this.lastPassKillerService.start();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public ngOnDestroy(): void {
    try {
      this.lastPassKillerService.stop();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public resetMainVariables(): void {
    try {
      this.alertColourProgress=AlertClassColour.Grey;
      this.newUsageTariff     =false;
      this.progressInformation=this.initialStatus;
      this.thisFormSubmitted  =false;
      this.usageTariff        =undefined;
      this.usageTariffId      =undefined;

      this.refreshBillingServiceTypeData();
      this.refreshCurrencyTypeData();
      this.refreshTariffTypeData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openForm(usageTariffId: number | undefined): void {
    try {
      this.resetMainVariables();
      this.setUpForm();
      this.enableDisableControls(false);

      if (usageTariffId != undefined && <number>usageTariffId>0) {
        this.usageTariffId=usageTariffId;

        this.getUsageTariffAndOpenModal();

      } else {
        this.newUsageTariff=true;

        this.openModal();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
      
  public getUsageTariffAndOpenModal() {
    try {
      this.tariffsUsageService.getById(<number>this.usageTariffId)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.usageTariff=data;
           
          this.populateFormFields(this.thisForm);
          this.openModal();
         },
        error: error => {
          this.thisFormCancelled.emit();
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openModal(): void {
    try {
      this.thisModalFormRef=this.modalService.open(this.thisModalForm, { backdrop: this.modalBackGround, 
                                                                         centered: true,
                                                                         keyboard: false,
                                                                         size    : msSize.Large });
    }
    catch(e) {
      this.thisFormCancelled.emit();
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region thisForm

  get formOfThis() {
    return this.thisForm.controls;
  }

  private setUpForm() {
    try {
      this.buildForm();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildForm() {
    try {
      this.removeFormFields(this.thisForm);

      this.thisForm=this.formBuilder.group({ });
      
      this.addFormFields(this.thisForm);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private addFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm) {
        this.addFormControl(formGroup, "active",               true, []);
        this.addFormControl(formGroup, "billingServiceTypeId", undefined, [Validators.required]);
        this.addFormControl(formGroup, "currencyTypeId",       undefined, [Validators.required]);
        this.addFormControl(formGroup, "tariffName",           undefined, [Validators.required, Validators.maxLength(this.tariffNameMaxLength)]);
        this.addFormControl(formGroup, "tariffTypeId",         undefined, [Validators.required]);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private addFormControl(form      : UntypedFormGroup,
                         dataField : string,
                         value     : boolean | number | string | undefined,
                         validators: Validators) {
    try {
      form.addControl(dataField, new FormControl(
        value,
        validators
      ));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private removeFormFields(form: UntypedFormGroup) {
    try {
      if (form != undefined) {
        for (let control in form.controls) {
          form.removeControl(control);
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private populateFormFields(formGroup: UntypedFormGroup) {
    try {
      if (formGroup==this.thisForm && this.usageTariff) {
        this.thisForm.controls["active"].setValue(this.usageTariff.active);
        this.thisForm.controls["billingServiceTypeId"].setValue(this.usageTariff.serviceID);
        this.thisForm.controls["currencyTypeId"].setValue(this.usageTariff.currencyTypeID);
        this.thisForm.controls["tariffName"].setValue(this.usageTariff.tariffName);
        this.thisForm.controls["tariffTypeId"].setValue(this.usageTariff.tariffTypeID);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private enableDisableControls(enabled: boolean) {
    try {
      
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmitAttempt() {
    try {
      this.thisFormSubmitted=true;

      if (this.thisForm.valid) {
          this.thisFormSubmit();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormSubmit() {
    try {
      this.prepareToSaveUsageTariff();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  public thisFormCancel() {
    try {
      this.thisFormCancelled.emit();
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Dropdown Arrays

  public getDropdownDataObjectArray(fieldName: string) {
    try {
      if (fieldName=="billingServiceTypeId") {
        return this.billingServiceTypeIdData;
      
      } else if (fieldName=="currencyTypeId") {
        return this.currencyTypeIdData;

      } else if (fieldName=="tariffTypeId") {
        return this.tariffTypeIdData;

      }
      
      return undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return undefined;
    }
  }

  private getDropdownData(dataSource: Observable<any>, fieldName: string) {
    try {
      if (dataSource) {
        dataSource
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            if (fieldName=="billingServiceTypeId") {
              this.billingServiceTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="currencyTypeId") {
              this.currencyTypeIdData=(data as IdAndDescriptionDTO[]);

            } else if (fieldName=="tariffTypeId") {
              this.tariffTypeIdData=(data as IdAndDescriptionDTO[]);

            }
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region Refresh Dropdown Arrays Data

  public refreshBillingServiceTypeData() {
    try {
      this.getDropdownData(this.typesBillingServiceService.getIdAndDescription(), "billingServiceTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshCurrencyTypeData() {
    try {
      this.getDropdownData(this.typesCurrencyService.getIdAndDescription(), "currencyTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public refreshTariffTypeData() {
    try {
      this.getDropdownData(this.typesTariffService.getIdAndDescription(), "tariffTypeId");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  //#endregion
  
  private prepareToSaveUsageTariff() {
    try
    {
      let usageTariff: TariffUsageDTO={
        active        : this.thisForm.controls["active"].value,
        currencyTypeID: this.thisForm.controls["currencyTypeId"].value,
        enteredBy     : this.curUser.userId,
        id            : this.usageTariffId ?? -1,
        serviceID     : this.thisForm.controls["billingServiceTypeId"].value,
        tariffName    : this.thisForm.controls["tariffName"].value,
        tariffTypeID  : this.thisForm.controls["tariffTypeId"].value
      };
                  
      this.saveUsageTariff(usageTariff)
      .pipe(
        catchError((error) => {
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: data => {
          this.processComplete();
                  
          if (this.newUsageTariff) {
            this.usageTariffId=data["id"];
          }
          
          this.thisFormSaved.emit(this.usageTariffId);
        },
        error: error => {
          this.alertColourProgress=AlertClassColour.Red;
          this.progressInformation=`Process cannot continue - ${error.message}`;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
                  
  private saveUsageTariff(usageTariff: TariffUsageDTO): Observable<TariffUsageDTO> {
    return this.tariffsUsageService.save(usageTariff);
  }

  //#region Process Complete

  private processComplete() {
    try {
      this.completedModalForm.openForm(this.newUsageTariff ? "Usage Tariff Created" : "Usage Tariff Details Updated", "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public completedModalFormClosed() {
    try {
      this.thisModalFormRef.close();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
